import { render } from "./VideoModalPlayer.vue?vue&type=template&id=32331b4f&scoped=true"
import script from "./VideoModalPlayer.vue?vue&type=script&lang=js"
export * from "./VideoModalPlayer.vue?vue&type=script&lang=js"

import "./VideoModalPlayer.vue?vue&type=style&index=0&id=32331b4f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32331b4f"]])

export default __exports__